import type { NpcId } from './enums';

/**
 * The v1 cast's names (docs/design/cast): Chinese in the Chinese UI, English in the English one.
 * Authored Chinese text writes the English name (「Chloe 說」); `chineseNames` swaps it on the way out,
 * so stories, dossiers and greetings all read 沈一諾 without the content being rewritten.
 */
export const CAST_NAMES: Partial<Record<NpcId, { zh: string; en: string }>> = {
  chloe: { zh: '沈一諾', en: 'Chloe' },
  mia: { zh: '葉向晴', en: 'Mia' },
  emma: { zh: '程曉然', en: 'Emma' },
  ethan: { zh: '周家朗', en: 'Ethan' },
  daniel: { zh: '陸子恆', en: 'Daniel' },
  leo: { zh: '溫以弦', en: 'Leo' },
  amber: { zh: '甘心怡', en: 'Amber' },
  june: { zh: '簡知秋', en: 'June' },
  tessa: { zh: '蘇曼寧', en: 'Tessa' },
  max: { zh: '甘星宇', en: 'Max' },
  theo: { zh: '林望舒', en: 'Theo' },
  sam: { zh: '高漾', en: 'Sam' },
  hazel: { zh: '何嘉慧', en: 'Hazel' },
  rosa: { zh: '羅美玲', en: 'Rosa' },
  nathan: { zh: '莫景行', en: 'Nathan' },
  ivan: { zh: '祁晏', en: 'Ivan' },
};

const ZH_BY_EN = new Map(Object.values(CAST_NAMES).map((n) => [n.en, n.zh]));
// A cast name standing as a word: not inside a longer Latin word and not a possessive brand
// (Hazel’s Bakery keeps its sign). The optional spaces around it are the gaps authored text leaves
// between Latin and Chinese, dropped when the name turns Chinese.
const NAME = new RegExp(`( ?)(?<![A-Za-z])(${[...ZH_BY_EN.keys()].join('|')})(?![A-Za-z]|[’']s)( ?)`, 'g');
const LATIN = /[A-Za-z0-9]/;

/** Chinese text with the cast's English names swapped for their Chinese ones. */
export function chineseNames(text: string): string {
  if (!/[A-Z]/.test(text)) return text;
  return text.replace(NAME, (_m, before: string, en: string, after: string, at: number, all: string) => {
    const prev = all[at - 1] ?? '';
    const next = all[at + before.length + en.length + after.length] ?? '';
    // Keep a space only where it still separates the name from Latin text.
    return `${before && LATIN.test(prev) ? ' ' : ''}${ZH_BY_EN.get(en)!}${after && LATIN.test(next) ? ' ' : ''}`;
  });
}
